import { Dialog } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { CircularProgress } from '@mui/material';

import useTranslation from 'customHooks/translate';
import { DIALOG_CLOSE_STATUS_BACKDROP } from 'consts';

interface IProps {
  open: boolean;
  children: React.ReactNode;
  handleClose?: () => void;
  title: string;
  buttonTitle: string;
  onSubmit: (event) => void;
  isLoading?: boolean;
  hasOwnButton?: boolean;
  disabled?: boolean;
}

const CustomDialog = ({
  open,
  children,
  handleClose,
  title,
  onSubmit,
  isLoading,
  buttonTitle,
  hasOwnButton = false,
  disabled,
}: IProps) => {
  const translation = useTranslation();

  return (
    <Dialog
      open={open}
      className="custom-dialog"
      disableEscapeKeyDown
      onClose={(event, reason) => {
        if (reason === DIALOG_CLOSE_STATUS_BACKDROP) return;
        handleClose?.();
      }}
    >
      <div className="flex flex-col gap-[20px]">
        <div className="mb-[10px] flex items-baseline justify-between gap-[10px]">
          <p className="text-[20px] font-medium text-[#1D1D1D] md:text-[24px]">
            {disabled ? translation.partners.PartnerInfo : title}
          </p>
          {handleClose ? (
            <div className="flex items-center justify-end">
              <div
                className="flex h-[24px] w-[24px] cursor-pointer items-center justify-center rounded-[4px] border border-[#292D32]"
                onClick={handleClose}
              >
                <CloseIcon className="close-icon" />
              </div>
            </div>
          ) : null}
        </div>
        {children}
        {!hasOwnButton && !disabled && (
          <button
            onClick={onSubmit}
            type="submit"
            className="w-full rounded-[8px] bg-[#6dcd90] px-[24px] py-[12px] text-[14px] font-normal leading-[16px] text-white md:text-[16px]"
          >
            {isLoading ? <CircularProgress size={22} /> : buttonTitle}
          </button>
        )}
      </div>
    </Dialog>
  );
};

export default CustomDialog;
